import React from 'react';
import { ModalHeader } from '../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../CommonComponents/OPL/Modal/Modal';
import { Alert } from '../../CommonComponents/OPL/Alert/Alert';
import { useDeleteCampaignMutation } from '../api/useDeleteCampaignMutation';
import { CampaignDTO } from '../api/useCampaignsQuery';

interface Props {
  campaign: CampaignDTO;
  onClose(): void;
  onDelete(): void;
}

export const DeleteCampaignModal = ({ campaign, onClose, onDelete }: Props) => {
  const {
    mutateAsync: deleteCampaign,
    isLoading: isDeletingCampaign,
    error: deleteCampaignError,
  } = useDeleteCampaignMutation();

  const handleDeleteCampaign = async () => {
    try {
      await deleteCampaign({ campaignId: campaign.id });

      onDelete();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'campaign--delete-campaign--modal-header' }}
    >
      <ModalHeader as="h2" id="campaign--delete-campaign--modal-header">
        Are you sure you want to delete this campaign?
      </ModalHeader>

      {deleteCampaignError && (
        <Alert message={deleteCampaignError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody>{campaign.name}</ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="error"
          isLoading={isDeletingCampaign}
          onClick={handleDeleteCampaign}
          ml="8"
        >
          Delete Campaign
        </Button>
      </ModalFooter>
    </Modal>
  );
};
